// NOTE: 跟进libphonenumber-js识别识别HK电话号为invalid
// https://catamphetamine.gitlab.io/libphonenumber-js/?parseCountry=HK&parseValue=5441125&asYouTypeCountry=US&asYouTypeValue=852&findNumbersCountry=US&findNumbersText=For%20more%20details%20call%20%2B7%20(800)%20555-35-35%20internationally%20or%20reach%20the%20local%20US%20branch%20at%20(213)%20373-4253%20ext.%201234%20for%20paid%20customer%20support.
const POSSIBLE_COUNTRY_SHORT_LIST = ['HK'];

export { POSSIBLE_COUNTRY_SHORT_LIST };
